import React from "react";
import CustomTitle from "./CustomTitle";

const MainContent = React.forwardRef(
  (
    {
      navTitle,
      title,
      children,
    }: {
      navTitle?: React.ReactNode;
      title?: React.ReactNode;
      children: React.ReactNode;
    },
    ref: React.ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <div className="flex flex-col h-full">
        {navTitle && (
          <p className="text-3xl font-bold text-dark-blue font-faune">
            {navTitle}
          </p>
        )}
        <div className="h-full bg-white my-7 p-7 rounded-[30px]" ref={ref}>
          {title && <CustomTitle title={title} />}
          {children}
        </div>
      </div>
    );
  }
);

export default MainContent;
